import { forwardRef } from 'react';

const Services = forwardRef<HTMLElement>((props, ref) => {
  const scrollToContact = () => {
    const contactSection = document.querySelector('section:last-of-type');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      ref={ref}
      className="py-12 px-[4%] opacity-0 transition-all duration-1000 bg-gradient-to-b from-[#EDE4D8] to-[#E8DFD3]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="rounded-3xl overflow-hidden shadow-2xl border-2 border-[#D4AF37]/30">
          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Sol Kolon - Kurumsal İş Birliği (Koyu) */}
            <div className="bg-gradient-to-br from-[#1A365D] to-[#0F2747] py-16 px-8 lg:px-12 relative overflow-hidden">
              {/* Decorative elements */}
              <div className="absolute top-10 left-10 w-20 h-20 rounded-full bg-[#D4AF37]/5 blur-2xl"></div>
              <div className="absolute bottom-10 right-10 w-32 h-32 rounded-full bg-[#D4AF37]/5 blur-3xl"></div>

              {/* Sparkle stars */}
              <div
                className="absolute top-8 right-[20%] w-2 h-2 star-4 animate-twinkle"
                style={{ backgroundColor: 'rgba(212, 175, 55, 0.3)', animationDelay: '0s' }}
              ></div>
              <div
                className="absolute bottom-12 left-[15%] w-1.5 h-1.5 star-4 animate-twinkle"
                style={{ backgroundColor: 'rgba(214, 184, 146, 0.25)', animationDelay: '1s' }}
              ></div>

              <div className="relative z-10 max-w-md mx-auto text-center">
                {/* Icon */}
                <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#D4AF37]/10 flex items-center justify-center border border-[#D4AF37]/30">
                  <i className="ri-building-2-line text-[#D4AF37] text-2xl"></i>
                </div>

                {/* Title */}
                <h3 className="font-cormorant text-3xl lg:text-4xl text-white mb-4">
                  Kurumsal İş Birliği
                </h3>

                {/* Description */}
                <p className="text-[#B8C5D6] text-sm leading-relaxed mb-6 min-h-[5rem]">
                  Şirket etkinlikleri, toplantı ikramları ve ofis kahvaltıları için özel menüler hazırlıyoruz.
                </p>

                {/* Features */}
                <div className="space-y-3 mb-8">
                  <div className="flex items-center justify-center gap-2 text-[#B8C5D6] text-sm">
                    <i className="ri-check-line text-[#D4AF37]"></i>
                    <span>Toplu sipariş indirimi</span>
                  </div>
                  <div className="flex items-center justify-center gap-2 text-[#B8C5D6] text-sm">
                    <i className="ri-check-line text-[#D4AF37]"></i>
                    <span>Kurumsal fatura</span>
                  </div>
                </div>

                {/* CTA Button */}
                <button
                  onClick={scrollToContact}
                  className="bg-[#D4AF37] text-[#1A365D] px-8 py-3 rounded-lg font-semibold hover:bg-[#E8C55B] transition-all duration-300 cursor-pointer inline-flex items-center gap-2 group"
                >
                  <span>İletişime Geçin</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>

            {/* Sağ Kolon - Özel Sipariş (Açık) */}
            <div className="bg-gradient-to-br from-[#F5EDE4] to-[#EDE4D8] py-16 px-8 lg:px-12 relative overflow-hidden">
              {/* Decorative elements */}
              <div className="absolute top-10 right-10 w-24 h-24 rounded-full bg-[#D4AF37]/10 blur-2xl"></div>
              <div className="absolute bottom-10 left-10 w-20 h-20 rounded-full bg-[#1A365D]/5 blur-2xl"></div>

              <div className="relative z-10 max-w-md mx-auto text-center">
                {/* Icon */}
                <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#1A365D]/10 flex items-center justify-center border border-[#1A365D]/20">
                  <i className="ri-gift-2-line text-[#1A365D] text-2xl"></i>
                </div>

                {/* Title */}
                <h3 className="font-cormorant text-3xl lg:text-4xl text-[#1A365D] mb-4">
                  Özel Sipariş
                </h3>

                {/* Description */}
                <p className="text-[#64748B] text-sm leading-relaxed mb-6 min-h-[5rem]">
                  Doğum günleri, yıl dönümleri ve özel kutlamalarınız için talebinize uygun pastalar ve tatlılar hazırlıyoruz. Hayalinizdeki lezzeti birlikte tasarlayalım.
                </p>

                {/* Features */}
                <div className="space-y-3 mb-8">
                  <div className="flex items-center justify-center gap-2 text-[#64748B] text-sm">
                    <i className="ri-check-line text-[#D4AF37]"></i>
                    <span>Kişiye özel tasarım</span>
                  </div>
                  <div className="flex items-center justify-center gap-2 text-[#64748B] text-sm">
                    <i className="ri-check-line text-[#D4AF37]"></i>
                    <span>Özel gün pastaları</span>
                  </div>
                </div>

                {/* CTA Button */}
                <button
                  onClick={scrollToContact}
                  className="bg-[#1A365D] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#2B4C7E] transition-all duration-300 cursor-pointer inline-flex items-center gap-2 group"
                >
                  <span>Sipariş Verin</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

Services.displayName = 'Services';

export default Services;
